import type React from "react";
import { askDiscard } from "./DiscardPrompt";

/**
 * Props de fechamento para o backdrop (div fixed) de qualquer modal:
 *   <div {...backdropClose(onClose)} style={...}>
 *
 * - Só fecha se mousedown E mouseup caíram no próprio backdrop (arrastar de
 *   dentro do painel e soltar fora não fecha).
 * - Se algum campo dentro foi editado desde a abertura (evento `input` que
 *   borbulhou até aqui; flag guardado no próprio nó do backdrop), abre o
 *   DiscardPrompt (nosso, não o do navegador) antes de fechar. Modais com
 *   guard próprio (dirty/save) passam `guarded: true` e pulam esse check.
 */
export function backdropClose(
  onClose: () => void,
  { guarded = false } = {},
): Pick<React.HTMLAttributes<HTMLDivElement>, "onMouseDown" | "onMouseUp" | "onInput"> {
  return {
    onInput: (e) => { e.currentTarget.dataset.edited = "1"; },
    onMouseDown: (e) => { e.currentTarget.dataset.armed = e.target === e.currentTarget ? "1" : ""; },
    onMouseUp: (e) => {
      const el = e.currentTarget;
      const hit = el.dataset.armed === "1" && e.target === el;
      el.dataset.armed = "";
      if (!hit) return;
      if (!guarded && el.dataset.edited) { askDiscard(onClose); return; }
      onClose();
    },
  };
}
